import * as React from "react";
import PropTypes from "prop-types";
const SvgActionsLockClosedNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M4 8v2.17A3.001 3.001 0 002 13v7a3 3 0 003 3h14a3 3 0 003-3v-7a3.001 3.001 0 00-2-2.83V8A8 8 0 104 8zm8-6a6 6 0 016 6v2h-2V8a4 4 0 00-8 0v2H6V8a6 6 0 016-6zM5 12h14a1 1 0 011 1v7a1 1 0 01-1 1H5a1 1 0 01-1-1v-7a1 1 0 011-1zm5-2V8a2 2 0 114 0v2z"
        fill=""
      />
    </svg>
  )
);
SvgActionsLockClosedNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActionsLockClosedNormalSmall;
